// ----------------------------------------------------------------------
// <copyright file="Izenda.MyPreferenceRole.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {

  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var ObservablePropTypes = require('mobx-react').propTypes;

  var MyPreferenceRole = function (props) {
    var currentUser = props.store.model;
    var localization = props.localization;

    return (
      <GridLayout.Row>
        <GridLayout.Col cols='2'>
          <span className='u_controlHeight control-label'>{localization.getText('COMMON_LABEL_ROLE')}</span>
        </GridLayout.Col>
        <GridLayout.Col cols='10'>
          <ul>
            {
              currentUser.roles && currentUser.roles.map(function (role) {
                return (
                <li key={role.id}>{role.name}</li>);
              })
            }
          </ul>

        </GridLayout.Col>
      </GridLayout.Row>
    );
  };

  MyPreferenceRole.propTypes = {
    store: ObservablePropTypes.observableObject.isRequired
  };

  module.exports = connect()(MyPreferenceRole);
})();


// WEBPACK FOOTER //
// ./ui/modules/MyProfile/MyPreference/Izenda.MyPreferenceRole.jsx